"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var isFocused = function isFocused(el) {
  return document.activeElement === el;
};
var isTag = function isTag(el, tagName) {
  return el && typeof el.tagName === 'string' && el.tagName.toLowerCase() === tagName.toLowerCase();
};
var isInput = function isInput(el) {
  return isTag(el, 'input');
};
var isFocusedInput = function isFocusedInput(el) {
  return isInput(el) && isFocused(el);
};
var isCheckbox = function isCheckbox(el) {
  return isInput(el) && el.type && el.type.toLowerCase() === 'checkbox';
};
var isSelect = function isSelect(el) {
  return isTag(el, 'select');
};
var isTextArea = function isTextArea(el) {
  return isTag(el, 'textarea');
};
var isFocusedTextArea = function isFocusedTextArea(el) {
  return isFocused(el) && isTextArea(el);
};
var ReactFastClick = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ReactFastClick, _Component);
  var _super = (0, _createSuper2.default)(ReactFastClick);
  function ReactFastClick() {
    var _this;
    (0, _classCallCheck2.default)(this, ReactFastClick);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      touchId: null,
      touchX: null,
      touchY: null,
      touchTime: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchStart", function (e) {
      // one+ touches means the user isn't trying to tap this element
      if (e.touches.length !== 1 || e.targetTouches.length !== 1) {
        _this.clearTouchData();
        return;
      }
      var tch = e.targetTouches[0];
      _this.setState({
        touchId: tch.identifier,
        touchX: tch.screenX,
        touchY: tch.screenY,
        touchTime: new Date().getTime()
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchMove", function (e) {
      var touchId = _this.state.touchId;
      var threshold = _this.props.threshold;
      if (touchId === null) {
        return;
      }
      if (e.touches.length !== 1 || e.targetTouches.length !== 1) {
        _this.clearTouchData();
        return;
      }
      var touch = e.targetTouches[0];
      if (touchId !== touch.identifier) {
        _this.clearTouchData();
        return;
      }

      // verify that the touch did not move outside the threshold
      var dist = _this.calculateTouchDistanceFromOrigin(touch);
      // if it was moved farther than the allowed amount, then we should cancel the touch
      if (dist > threshold) {
        _this.clearTouchData();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchEnd", function (e) {
      var _this$state = _this.state,
        touchId = _this$state.touchId,
        touchTime = _this$state.touchTime;
      var _this$props = _this.props,
        timeThreshold = _this$props.timeThreshold,
        threshold = _this$props.threshold;
      if (touchId === null) {
        return;
      }
      if (timeThreshold !== null) {
        // length of press exceeds the amount of time that we are doing anything for
        if (new Date().getTime() - touchTime > timeThreshold) {
          _this.clearTouchData();
          return;
        }
      }

      // still a touch remaining
      if (e.touches.length !== 0) {
        _this.clearTouchData();
        return;
      }

      // get the touch from the list of changed touches
      var touch = null;
      for (var i = 0; i < e.changedTouches.length; i++) {
        var oneTouch = e.changedTouches[i];
        if (oneTouch.identifier === _this.state.touchId) {
          touch = oneTouch;
          break;
        }
      }
      if (touch === null) {
        _this.clearTouchData();
        return;
      }

      // verify that the touch did not move outside the threshold
      var dist = _this.calculateTouchDistanceFromOrigin(touch);
      // if it was moved farther than the allowed amount, then we should cancel the touch
      if (dist > threshold) {
        _this.clearTouchData();
        return;
      }
      var targetEl = touch.target;

      // if it's an input where typing is allowed and it's already focused,
      // don't do anything. this is probably an attempt to move the cursor
      if ((isFocusedInput(targetEl) || isFocusedTextArea(targetEl)) && !isCheckbox(targetEl)) {
        _this.clearTouchData();
        return;
      }

      // prevent the simulated mouse events
      e.preventDefault();
      // we don't need this touch end event to be handled multiple times if it's interpreted as a click
      e.stopPropagation();
      // clear the data and then trigger the click
      _this.clearTouchData(function () {
        ReactFastClick.triggerClick(targetEl);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchCancel", function (e) {
      _this.clearTouchData();
    });
    return _this;
  }
  (0, _createClass2.default)(ReactFastClick, [{
    key: "shouldComponentUpdate",
    value:
    /**
     * We only re-render if the children have changed-the state changes in this component do not affect the rendered html
     * @param nextProps
     * @returns {boolean}
     */
    function shouldComponentUpdate(nextProps) {
      return this.props.children !== nextProps.children;
    }

    /**
     * Clear all touch data
     * @param callback
     */
  }, {
    key: "clearTouchData",
    value: function clearTouchData(callback) {
      this.setState({
        touchId: null,
        touchX: null,
        touchY: null,
        touchTime: null
      }, callback);
    }

    /**
     * Handle the touch start event
     * @param e
     */
  }, {
    key: "calculateTouchDistanceFromOrigin",
    value: function calculateTouchDistanceFromOrigin(touch) {
      var _this$state2 = this.state,
        touchX = _this$state2.touchX,
        touchY = _this$state2.touchY;
      var screenX = touch.screenX,
        screenY = touch.screenY;
      return Math.sqrt(Math.pow(screenX - touchX, 2) + Math.pow(screenY - touchY, 2));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var touchProps = {
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onTouchCancel: this.handleTouchCancel
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, touchProps), {}, {
        children: [" ", children, " "]
      }));
    }
  }], [{
    key: "triggerClick",
    value: function triggerClick(target) {
      while (target && typeof target.click !== 'function') {
        target = target.parentNode;
      }
      if (!target) {
        return;
      }
      target.click();

      // if it's an input and not a checkbox, focus it
      // or if it's a select
      // or if it's a textarea
      if (isInput(target) && !isCheckbox(target) || isSelect(target) || isTextArea(target)) {
        target.focus();
      }
    }
  }]);
  return ReactFastClick;
}(_react.Component);
exports.default = ReactFastClick;
(0, _defineProperty2.default)(ReactFastClick, "propTypes", {
  // The number of px that the finger may move before the gesture is no longer considered a tap
  threshold: _propTypes.default.number,
  // The amount of time in ms that the finger may be down before the gesture is no longer considered a tap by this
  // component
  timeThreshold: _propTypes.default.number
});
(0, _defineProperty2.default)(ReactFastClick, "defaultProps", {
  threshold: 15,
  // 按压时间超过这个值的 touchend 会使用原生 click，不产生假 click
  // 这个时间要尽量长，修改的话注意一定要测 iOS 10 独立 App（UIWebView）
  timeThreshold: 1000
});